import { ref } from 'vue';
import { useNewsletterType } from './useNewsletterType';

const EMAIL_MODEL = {
	email: null
};
const SUBSCRIBE_MODEL = {
	...EMAIL_MODEL,
	name: null,
	gwb: null,
	clientType: null,
	newsletterTypes: [],
	acceptPrivacyStatement: null
};
const model = ref(null);
export const useForm = (newsletterType) => {
	const { isSubscribe } = useNewsletterType(newsletterType);
	if (!model.value && isSubscribe.value) {
		model.value = { ...SUBSCRIBE_MODEL };
	} else if (!model.value && !isSubscribe.value) {
		model.value = { ...EMAIL_MODEL };
	}
	return { model };
};
